// dialogs/crawler-config-dialog/crawler-config-dialog.component.ts

import { Component, computed, inject, Signal, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Crawler,
  CrawlerOutput,
  CrawlerType,
  ExcelBatchCrawlerSpec,
  IntegrationWithCrawler,
} from 'src/app/models/integration/crawler';
import { Integration } from 'src/app/models/integration/integration';
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatDivider} from "@angular/material/divider";
import {TranslateModule} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";
import {CrawlStatusComponent} from "src/app/components/crawl-status/crawl-status.component";

@Component({
  selector: 'app-crawler-config-dialog',
  templateUrl: './crawler-config-dialog.component.html',
  styleUrls: ['./crawler-config-dialog.component.scss'],
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatDivider,
    TranslateModule,
    DatePipe,
    CrawlStatusComponent
  ]
})
export class CrawlerConfigDialogComponent {
  private readonly data = inject<{ integration: IntegrationWithCrawler }>(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<CrawlerConfigDialogComponent> = inject(MatDialogRef);

  protected readonly integration = signal<Integration>(this.data.integration.integration);
  protected readonly crawler = signal<Crawler>(this.data.integration.crawler);

  // File name, URL column and output only exist on the Excel-batch spec.
  protected readonly excelSpec: Signal<ExcelBatchCrawlerSpec | undefined> = computed(() => {
    const crawler = this.crawler();
    return crawler.type === CrawlerType.EXCEL_BATCH ? crawler.spec : undefined;
  });

  protected readonly output: Signal<CrawlerOutput | undefined> = computed(
    () => this.excelSpec()?.output,
  );

  onClose() {
    this.dialogRef.close();
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }
}
